import FJActionConstant from "../../constant/FJActionConstant";
import FJRatioStore from "../../store/FJRatioStore";

const initState = {
  ratioType: FJRatioStore.allRatioType().landscape,
  previewRatioType: '',
}

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_RATIO_TYPE: {
      return {
        ...state,
        ratioType: action.ratioType,
      }
    }
    case FJActionConstant.SET_PREVIEW_RATIO_TYPE: {
      return {
        ...state,
        previewRatioType: action.ratioType,
      }
    }
    default:
      return state;
  }
}
